import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Spinner } from '@lux/components-gomo';

export const LoadingIndicator = ({ requestNames, loading }) => {
  let showLoading = requestNames.some(requestName => !!loading[requestName]);
  return showLoading ? (
    <LoadingOverlay>
      <Spinner show={true} />
    </LoadingOverlay>
  ) : null;
};

LoadingIndicator.propTypes = {
  requestNames: PropTypes.array,
  loading: PropTypes.object
};

LoadingIndicator.defaultProps = {
  requestNames: [],
  loading: {}
};

export const mapStateToProps = state => ({
  loading: state.loading
});

const ConnectedLoadingIndicator = connect(mapStateToProps)(LoadingIndicator);
ConnectedLoadingIndicator.propTypes = LoadingIndicator.propTypes;

export default ConnectedLoadingIndicator;

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;
